"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [
    ...fragments_1.telegramTargetFragmentDependencies,
    fragments_1.telegramTargetFragment,
];
const MUTATION = `
query getTelegramTargets {
  telegramTarget {
    ...telegramTargetFragment
  }
}
`.trim();
const getTelegramTargetsImpl = (0, notifi_axios_utils_1.makeParameterLessRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'telegramTarget');
exports.default = getTelegramTargetsImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0VGVsZWdyYW1UYXJnZXRzSW1wbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9xdWVyaWVzL2dldFRlbGVncmFtVGFyZ2V0c0ltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw0Q0FHc0I7QUFDdEIsMkVBRzRDO0FBRzVDLE1BQU0sWUFBWSxHQUFHO0lBQ25CLEdBQUcsOENBQWtDO0lBQ3JDLGtDQUFzQjtDQUN2QixDQUFDO0FBRUYsTUFBTSxRQUFRLEdBQUc7Ozs7OztDQU1oQixDQUFDLElBQUksRUFBRSxDQUFDO0FBRVQsTUFBTSxzQkFBc0IsR0FDMUIsSUFBQSw2Q0FBd0IsRUFDdEIsSUFBQSx3Q0FBbUIsRUFBQyxHQUFHLFlBQVksRUFBRSxRQUFRLENBQUMsRUFDOUMsZ0JBQWdCLENBQ2pCLENBQUM7QUFFSixrQkFBZSxzQkFBc0IsQ0FBQyJ9